import { Component } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { Modal } from '@app/core/models/modal.model';
import { ModalAction } from '@app/core/models/modal-action.model';
import { FinanceQuote } from '@app/core/models/finance-quote.model';
import { TrackingService } from '@app/core/services/tracking.service';
import { SkipFinanceService } from '@app/configure/services/skip-finance.service';

@Component({
	selector: 'cng-finance-apply-modal',
	templateUrl: './finance-apply.component.html',
})
export class ConfigureFinanceApplyModalComponent {
	quote: FinanceQuote;

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ModalService} modal_service
	 * @param {ConfigureService} configure_service
	 * @param {TrackingService} tracking_service
	 * @param {SkipFinanceService} skip_finance_service
	 */
	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private tracking_service: TrackingService,
		private skip_finance_service: SkipFinanceService
	) {
		this.constructModal();
	}

	/**
	 * Constructs modal.
	 */
	constructModal(): void {
		this.quote = this.modal_service.data.quote;

		this.modal_service.setConfig(
			new Modal({
				name: 'finance_apply_modal',
				title: 'Finance application',
				actions: [
					new ModalAction({
						id: 'cancel',
						name: 'Cancel',
						large: true,
						click: () => {
							this.modal_service.close();
						},
					}),
					new ModalAction({
						id: 'continue',
						name: 'Continue',
						bias: 'positive',
						large: true,
						path: this.quote.apply_url,
						target: '_blank',
						showLoading: true,
						click: (action: ModalAction) => {
							this.configure_service
								.setPreferredFinanceFacilityType(this.quote.facility_type)
								.subscribe(() => {
									action.loading = false;
									// this.skip_finance_service.onDidSetFinanceFacilityType.next(true);
									this.modal_service.close();
								});

							this.tracking_service.trackFinanceApplyIntent();
						},
					}),
				],
			})
		);
	}
}
